import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPnLReport } from "./pnlService";
import PnLTable from "./PnLTable";
import { usePermissions } from "../../context/PermissionContext";

const PnLPage = () => {
  const navigate = useNavigate();
  const { canView } = usePermissions();
  const [items, setItems] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Date filters
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    fetchReport();
  }, []);

  const fetchReport = async () => {
    setLoading(true);
    try {
      const filters = {};
      if (startDate) filters.start_date = startDate;
      if (endDate) filters.end_date = endDate;
      
      const data = await getPnLReport(filters);
      setItems(data.items || []);
      setSummary(data.summary || null);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (!canView("report_pnl")) {
    return (
      <div className="container-fluid p-4 text-center">
        <div className="alert alert-danger p-4 shadow-sm" style={{ maxWidth: "600px", margin: "40px auto", borderRadius: "12px" }}>
          <h4 style={{ fontWeight: "700" }}>Access Denied</h4>
          <p style={{ margin: "12px 0", color: "#7f1d1d" }}>
            You do not have permission to view the Profit & Loss Report. Please contact your system administrator.
          </p>
          <button className="btn btn-secondary btn-sm" onClick={() => navigate("/dashboard")}>
            Back to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Profit & Loss Report</h3>
        <button className="btn btn-secondary btn-sm" onClick={() => navigate("/dashboard")}>
          Back to Dashboard
        </button>
      </div>
      <div className="d-flex justify-content-end mb-3">
        <div className="d-flex gap-2 align-items-end">
          <div>
            <label className="form-label small mb-1">Start Date</label>
            <input 
              type="date" 
              className="form-control form-control-sm" 
              value={startDate} 
              onChange={(e) => setStartDate(e.target.value)} 
            />
          </div>
          <div>
            <label className="form-label small mb-1">End Date</label>
            <input 
              type="date" 
              className="form-control form-control-sm" 
              value={endDate} 
              onChange={(e) => setEndDate(e.target.value)} 
            />
          </div>
          <button className="btn btn-primary btn-sm" onClick={fetchReport}>
            Filter
          </button>
        </div>
      </div>

      {loading ? (
        <div className="p-4 text-center">Loading report...</div>
      ) : (
        summary && <PnLTable data={items} summary={summary} />
      )}
    </div>
  );
};

export default PnLPage;
